<template>
  <div>
    <div class="bg-FF fixed width-100 z-99">
      <van-search v-model="queryParams.userName" placeholder="搜索员工姓名" readonly shape="round" show-action @click="openDeptUserTree">
        <template #action>
          <div class="w-110 h-66 l-h-66 bg-FFDA3E b-r-40 text-center" @click.stop="onSearch">搜索</div>
        </template>
      </van-search>

      <div class="flex row-between col-center p-l-16 p-r-16 p-t-10 p-b-12 font-28 cor-66">
        <div @click="isShowTimePopup()">
          筛选时间
          <van-icon class="m-l-6" name="play" style="transform: rotate(90deg);" />
        </div>
        <div>{{ sxsjLabel }}</div>
        <template>
          <van-popup v-model="sxsj.show" position="bottom">
            <van-tabs v-model="sxsj.active">
              <van-tab title="开始时间">
                <van-datetime-picker
                    v-model="queryParams.startTime"
                    :formatter="formatter"
                    :show-toolbar="false"
                    title="选择年月"
                    type="year-month"
                />
              </van-tab>
              <van-tab title="结束时间">
                <van-datetime-picker
                    v-model="queryParams.endTime"
                    :formatter="formatter"
                    :show-toolbar="false"
                    title="选择年月"
                    type="year-month"
                />
              </van-tab>
            </van-tabs>

            <div class="m-t-70 m-b-50 text-center">
              <van-button class="m-20 b-r-8" type="default" @click="sxsj.show = false">取 消</van-button>
              <van-button class="m-20 b-r-8" type="primary" @click="sxsjConfirm">确 定</van-button>
            </div>
          </van-popup>
        </template>
      </div>

      <!--员工树结构-->
      <DeptUserTree ref="deptUserTreeRef" :show-checkbox="false" @deptUserTreeSubmit="deptUserTreeSubmit" />
    </div>

    <!--内容区域-->
    <div class="p-l-20 p-r-20 p-b-20 p-t-180">
      <div class="staff-info width-100 p-20 ">
        <div class="flex col-center m-b-24">
          <img :src="userInfo.employeeImage ? userInfo.employeeImage : defaultImg" alt="" class="w-120 h-120 m-r-18" />
          <div class="width-80">
            <div class="flex col-center m-b-20 width-100">
              <span class="font-32 dis-in-b font-weight-600 m-r-10">{{ userInfo.nickName }}</span>
              <span class="font-28 dis-in-b width-55 ellipsis-1">{{ userInfo.postNames }}</span>
            </div>
            <div class="font-28">
              <span class="p-14 b-r-40 m-r-18" style="border: 1px solid #FFFFFF;">司龄:{{ userInfo.entryYears }}</span>
              <span v-if="userInfo.entryTime" class="p-14 b-r-40" style="border: 1px solid #FFFFFF;">入职: {{ moment(userInfo.entryTime).format('YYYY年MM月DD日') }}</span>
            </div>
          </div>
        </div>

        <div class="p-12 bg-D3DBFF flex row-around col-center b-r-8">
          <div v-for="(item, index) in tabs" :key="index" :class="{active: activeIndex === index }" class="font-28 p-t-8 p-b-8 p-l-18 p-r-18 cor-99" @click="selectTab(index)">{{ item.title }}</div>
        </div>
      </div>

      <!--  站位盒子  -->
      <div class="h-12"></div>
      <div class="tab-content">
        <div class="slide-transition">
          <!-- 核心信息 -->
          <CoreMessage v-if="activeIndex === 0" :boardData="coreInfo" :roleType="roleType" />
          <!-- 工作效能 -->
          <WorkEfficiency v-if="activeIndex === 1" :boardData="workInfo" :roleType="roleType" />
          <!-- 商务业绩 -->
          <BusinessPerformance v-if="activeIndex === 2 && roleType != 13" :boardData="businessInfo" :roleType="roleType" />
          <!-- 工作量统计 -->
          <WorkloadStatistics v-if="activeIndex === 2 && roleType == 13" :boardData="workloadInfo" :roleType="roleType"></WorkloadStatistics>
          <!-- 薪资绩效 -->
          <SalaryPerformance v-if="activeIndex === 3" :boardData="salaryInfo" :roleType="roleType" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixin/flow'
import moment from "moment";
import CoreMessage from '@/views/employeeKanban/components/coreMessage.vue'
import WorkEfficiency from '@/views/employeeKanban/components/workEfficiency.vue'
import BusinessPerformance from '@/views/employeeKanban/components/businessPerformance.vue'
import SalaryPerformance from '@/views/employeeKanban/components/salaryPerformance.vue'
import WorkloadStatistics from '@/views/employeeKanban/components/workloadStatistics.vue'
import DeptUserTree from "@/components/deptUserTree/index.vue";
import {methodGetApi} from "@/api/publicApi";
import cache from "@/plugins/cache";

export default {
  name: 'employeeKanbanIndex',
  mixins: [mixin],
  components: {
    DeptUserTree,
    CoreMessage,
    WorkEfficiency,
    BusinessPerformance,
    SalaryPerformance,
    WorkloadStatistics
  },
  data() {
    const now = new Date();
    const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    return {
      moment,
      userInfo: {},
      defaultImg: require('@/assets/icon/employeeKanban/avatar.png'),
      activeIndex: 0,
      tabs: [],
      coreInfo: {},
      workInfo: {},
      businessInfo: {},
      salaryInfo: {},
      workloadInfo: {},
      sxsjLabel: `${moment(lastMonth).format('YYYY-MM')} - ${moment(lastMonth).format('YYYY-MM')}`,
      queryParams: {
        userName: "",
        userId: "",
        deptId: "",
        startTime: moment(lastMonth).format('YYYY-MM'),
        endTime: moment(lastMonth).format('YYYY-MM'),
      },
      sxsj: {
        show: false,
        active: 0
      },
      roleType: null
    }
  },
  created() {
    const currentUserInfo = JSON.parse(cache.session.get("userInfo"))
    this.queryParams.userId = currentUserInfo.userId
    this.queryParams.deptId = currentUserInfo.deptId
    this.roleType = currentUserInfo.roleType
    if (this.roleType == 13) {
      this.tabs = [
        {title: '核心信息', apiUrl: '/ep/coreInfo', checkInApi: '/work/total/checkIn'},
        {title: '工作效能', apiUrl: '/ep/workInfo'},
        {title: '工作量统计', apiUrl: '/work/total/totalWork'},
        {title: '薪资绩效', apiUrl: '/ep/salaryInfo'}
      ]
    } else {
      this.tabs = [
        {title: '核心信息', apiUrl: '/ep/coreInfo', checkInApi: '/work/total/checkIn'},
        {title: '工作效能', apiUrl: '/ep/workInfo'},
        {title: '商务业绩', apiUrl: '/ep/businessInfo'},
        {title: '薪资绩效', apiUrl: '/ep/salaryInfo'}
      ]
    }

    // 获取用户基本信息
    this.getBaseInfo()
    // tab 数据
    this.loadTabData(0)
  },
  mounted() {
  },
  methods: {
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },
    isShowTimePopup() {
      this.sxsj.active = 0;
      this.sxsj.show = true;
      const now = new Date();
      const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      this.queryParams.startTime = lastMonth;
      this.queryParams.endTime = lastMonth;
    },
    sxsjConfirm() {
      this.queryParams.startTime = moment(this.queryParams.startTime).format('YYYY-MM')
      this.queryParams.endTime = moment(this.queryParams.endTime).format('YYYY-MM')

      if (moment(this.queryParams.endTime).isBefore(this.queryParams.startTime)) {
        this.$toast('开始时间不能大于结束时间')
      } else {
        this.sxsj.show = false
        this.sxsjLabel = `${this.queryParams.startTime}-${this.queryParams.endTime}`
        this.loadTabData(this.activeIndex)
      }
    },
    openDeptUserTree() {
      this.$refs.deptUserTreeRef.deptUserTreeAll.show = true
      this.$refs.deptUserTreeRef.deptUserTreeAll.treeData = {}
    },
    deptUserTreeSubmit(data) {
      this.queryParams.userName = data.name;
      this.queryParams.userId = data.id;
      this.queryParams.deptId = data.parentId;
      this.roleType = data.roleType;
      if (this.roleType == 13) {
      this.tabs = [
        {title: '核心信息', apiUrl: '/ep/coreInfo', checkInApi: '/work/total/checkIn'},
        {title: '工作效能', apiUrl: '/ep/workInfo'},
        {title: '工作量统计', apiUrl: '/work/total/totalWork'},
        {title: '薪资绩效', apiUrl: '/ep/salaryInfo'}
      ]
    } else {
      this.tabs = [
        {title: '核心信息', apiUrl: '/ep/coreInfo', checkInApi: '/work/total/checkIn'},
        {title: '工作效能', apiUrl: '/ep/workInfo'},
        {title: '商务业绩', apiUrl: '/ep/businessInfo'},
        {title: '薪资绩效', apiUrl: '/ep/salaryInfo'}
      ]
    }
      this.onSearch()
    },
    selectTab(index) {
      this.activeIndex = index;
      this.loadTabData(index);
    },
    async loadTabData(index) {
      const tab = this.tabs[index];
      const dataKey = this.getDataKeyByIndex(index)

      try {
        const res = await methodGetApi(tab.apiUrl, this.queryParams)

        if (index === 0) {
          try {
            const checkInRes = await methodGetApi(tab.checkInApi, this.queryParams)
            res.data.kqsj = checkInRes.data
          } catch (error) {
            console.error('获取考勤数据失败:', error)
            res.data.kqsj = {}
          }
        }
        this[dataKey] = res.data
      } catch (error) {
        console.error(`加载${this.tabs[index].title}数据失败:`, error)
      }
    },
    getDataKeyByIndex(index) {
      let keys = []
      if (index === 2 && this.roleType == 13) {
        keys = ['coreInfo', 'workInfo', 'workloadInfo', 'salaryInfo']
      } else {
        keys = ['coreInfo', 'workInfo', 'businessInfo', 'salaryInfo']
      }

      return keys[index] || 'coreInfo'
    },
    async onSearch() {
      this.coreInfo = {};
      this.workInfo = {};
      this.businessInfo = {};
      this.salaryInfo = {};
      this.workloadInfo = {};

      await this.getBaseInfo()
      await this.loadTabData(this.activeIndex)
    },
    /**
     * @description: 获取用户信息
     * @author: 孙小梅
     * @param {*}
     */
    getBaseInfo() {
      methodGetApi('/ep/baseInfo', this.queryParams).then(res => {
        this.userInfo = res.data
      })
    },
  }
}
</script>
<style lang="less" scoped>
::v-deep .van-tabs {
  .van-tabs__content {
    padding-top: 80px;
  }
}

.staff-info {
  border-radius: 4px;
  /* 效果样式1 */
  box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.08);
  background: linear-gradient(135.00deg, rgba(168, 190, 255, 0.7), rgba(131, 145, 252, 0.7) 100%);

  .active {
    background: linear-gradient(43.88deg, rgba(127, 126, 253, 1), rgba(112, 163, 254, 1) 73%);
    border-radius: 8px;
    color: #ffffff;
  }

  .tab-content {
    position: relative;

    .slide-transition {
      transition: transform 0.3s ease;
    }
  }
}
</style>
